import { Stack, TagsSelect, Text, useTheme } from "@bps/fluent-ui";
import { getPropertyAndIdentifierOptions } from "@libs/api/gateways/field/field-ops-gateway.utils";

interface DeviceSearchColumnSelectProps {
  customColumns: string[];
  setCustomColumns: (columns: string[]) => void;
}

export const DeviceSearchColumnSelect: React.FC<DeviceSearchColumnSelectProps> = ({
  customColumns,
  setCustomColumns
}) => {
  const theme = useTheme();
  const attributeTypeOptions = getPropertyAndIdentifierOptions();

  // eslint-disable-next-line typescript-eslint/no-unused-vars
  const fetchOptions = async (_?: string | undefined) => attributeTypeOptions;

  return (
    <Stack
      tokens={{ childrenGap: theme.spacing.s1 }}
      styles={{
        root: {
          borderColor: theme.semanticColors.variantBorder,
          borderWidth: 1,
          borderStyle: "solid",
          padding: theme.spacing.s1,
          minHeight: 100,
          width: "40%"
        }
      }}
    >
      <Text bold>Select Extra Columns</Text>
      <TagsSelect
        onChange={setCustomColumns}
        fetchOptions={fetchOptions}
        value={customColumns}
      />
    </Stack>
  );
};
